<template>
  <div
    class="container mx-auto min-h-screen flex flex-col items-center justify-center text-center"
  >
    <img src="@/convite/assets/images/timbeta-logo.png" class="h-16 rounded-lg" />
    <br/>
    <p>Parabéns! Seu convite TIM BETA chegou!!<p>
    <p>Mas para entrar para o BETA você precisa ter o APP TIM BETA instalado em seu celular.</p>
    <p>Faça a instalação do APP e depois acesse novamente o link que está no seu convite.</p>
    <p>Depois é só entrar para o Beta e aproveitar todos os benefícios que só quem é Beta tem!</p>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({});
</script>
